import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { Message } from "element-ui";
import { getToken } from "@/utils/auth"; // 验权

const whiteList = ["/login"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.permissions.length === 0) {
        const permissions = ["admin"]; // note: permissions must be a array! such as: ['editor','develop']
        store
          .dispatch("GetInfo", { permissions })
          .then(res => {
            // 拉取用户信息
            store.dispatch("GenerateRoutes", { permissions }).then(() => {
              // 根据permissions权限生成可访问的路由表
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            });
          })
          .catch(err => {
            store.dispatch("FedLogOut").then(() => {
              Message.error(err || "登录信息失效，请重新登录");
              next({ path: "/" });
            });
          });
        // store
        //   .dispatch("GetInfo")
        //   .then(res => {
        //     // 拉取用户信息
        //     const permissions = res.data.permissions; // note: permissions must be a array! such as: ['editor','develop']
        //     store.dispatch("GenerateRoutes", { permissions }).then(() => {
        //       // 根据permissions权限生成可访问的路由表
        //       router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
        //       next({ ...to, replace: true }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        //     });
        //   })
        //   .catch(err => {
        //     store.dispatch("FedLogOut").then(() => {
        //       Message.error(err || "登录信息失效，请重新登录");
        //       next({ path: "/" });
        //     });
        //   });
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.permissions, to.meta.permissions)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        // // 可删 ↑
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});
